// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7379a14","732":"ee01bdf9","977":"977c8e04"}[chunkId] + ".chunk.js";
};